require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/modules/collapsible-text.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/modules/collapsible-text.legacy.js
// module id = 714
// module chunks = 31